import styled from 'styled-components';

export const IconButtonStyle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background-color: #f4f4f4;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.4s ease-in-out all;
  svg {
    path {
      transition: 0.4s ease-in-out all;
    }
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.background.action};
    svg {
      path {
        fill: #fff;
      }
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent.hover};
    svg {
      path {
        fill: ${({ theme }) => theme.colors.background.action};
      }
    }
  }
`;
